import { render, staticRenderFns } from "./CreatorGalleryEditDetails.vue?vue&type=template&id=28041f37&"
import script from "./CreatorGalleryEditDetails.vue?vue&type=script&lang=js&"
export * from "./CreatorGalleryEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports